import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { FaEye } from "react-icons/fa6"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

const FilteredProfile = () => {

    const [filterData, setFilterData] = useState()
    const [loading, setLoading] = useState(true)
    const history = useHistory()
    const countApi = useSelector((state) => state.auth.countApi)
    const { t } = useTranslation()

    useEffect(() => {
        setLoading(true)
        API.get('/user/getFilteredCounts').then((filterRes) => {
            if (filterRes.status === 200) {
                setFilterData(filterRes.data.data)
                setLoading(false)
            }
        })
    }, [countApi])

    return (
        <motion.div className="flex flex-col h-full w-full gap-2 rounded-lg bg-white">
            {
                loading ? "Loading Please Wait..." : <motion.div className="h-full py-2  px-2 w-full flex flex-col gap-5">
                    <p className="px-2 font-bold text-primeColor text-xl py-2">{t('Filtered Profiles')}</p>
                    <motion.div className="flex cursor-pointer rounded-lg bg-primeColor/30 drop-shadow-md flex-row w-full items-center gap-5 px-2 py-2 justify-between" onClick={() => history.push('/wishList')} >
                        <p className="text-black font-bold text-md">{t('Shortlisted')}</p><p className="text-primeColor font-bold text-xl">{filterData.shortlistedCount}</p>
                    </motion.div>
                    <motion.div className="flex cursor-pointer rounded-lg bg-primeColor/30 drop-shadow-md flex-row w-full items-center gap-5 px-2 py-2 justify-between" onClick={() => history.push('/notInterested')}>
                        <p className="text-black font-bold text-md">{t('Not Interested')}</p><p className="text-primeColor font-bold text-xl">{filterData.notInterestedCount}</p>
                    </motion.div>
                    <motion.div className="flex cursor-pointer rounded-lg bg-primeColor/30 drop-shadow-md flex-row w-full items-center gap-5 px-2 py-2 justify-between" onClick={() => history.push('/downloadedProfiles')}>
                        <p className="text-black font-bold text-md">{t('Downloaded')}</p><p className="text-primeColor font-bold text-xl">{filterData.downloadedCount}</p>
                    </motion.div>
                </motion.div>
            }
        </motion.div>
    )
}

export default FilteredProfile